import React, { useEffect, useState } from "react";
import { Col, Modal, Row, Button, FormGroup, Checkbox, ControlLabel } from "react-bootstrap";
import { ALLOW_QUESTIONS, PARTICIPANT_PROFILE_PATH, PARTICIPANT_PROFILE_URL } from "../constants";
import { getMember } from "../../../../../api/cp";
import ParticipantFields from "./ParticipantFields";
import ParticipantPhoto from "./ParticipantPhoto";
import ParticipantMaterials from "./ParticipantMaterials";
import './styles.scss';

const ParticipantModal = (
    {
        eventKey,
        editableParticipant,
        isModalVisible,
        onEdit,
        onSave,
        onClose,
    }
) => {
    const [model, setModel] = useState(null);
    const [formErrors, setFormErrors] = useState({});

    const getParticipant = async (id) => {
        const member = await getMember(id);
        setModel(member || { [ALLOW_QUESTIONS]: true })
    }

    useEffect(() => {
        if (editableParticipant?.id) {
            getParticipant(editableParticipant.id)
        }
    }, [editableParticipant]);

    const validateFields = () => {
        const nameValidated = model && [model.nameRu || '', model.nameEn || ''].some(name => name.trim().length > 1);
        setFormErrors(errors => ({ ...errors, name: !nameValidated }));
        return nameValidated;
    }

    const handleChangeModel = (key, value) => {
        if (key === 'nameRu' || key === 'nameEn') {
            setFormErrors(errors => ({ ...errors, name: false }))
        };
        setModel({
            ...model,
            [key]: value,
        })
    };

    const handleSaveModel = async () => {
        if (!validateFields()) return;

        try {
            const response = await (editableParticipant ? onEdit(model) : onSave(model));
            if (response) {
                handleCloseModal();
            }
        } catch (e) {
            console.error(e)
        }
    };

    const handleCloseModal = () => {
        setModel(null);
        onClose();
    };

    return (
        <Modal
            bsSize="large"
            show={isModalVisible}
            onHide={handleCloseModal}
            className="participant-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title>{editableParticipant ? 'Редактировать данные' : 'Добавить'} участника</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col xs={3}>
                        <ParticipantPhoto
                            image={model?.[PARTICIPANT_PROFILE_PATH] ? model?.[PARTICIPANT_PROFILE_URL] : null}
                            onChange={handleChangeModel}
                        />
                        <FormGroup>
                            <Checkbox
                                checked={model?.[ALLOW_QUESTIONS]}
                                name="hidden"
                                onChange={(e) => handleChangeModel(ALLOW_QUESTIONS, e.target.checked)}
                            >
                                Разрешить задавать вопросы от зрителей
                            </Checkbox>
                        </FormGroup>
                    </Col>
                    <Col xs={9}>
                        <ParticipantFields
                            eventKey={eventKey}
                            model={model}
                            formErrors={formErrors}
                            onChange={handleChangeModel}
                        />
                        {(editableParticipant && model) && <ParticipantMaterials member={model} />}                        
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => handleSaveModel(model)}>
                    Сохранить
                </Button>
                <Button onClick={handleCloseModal}>
                    Закрыть
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ParticipantModal;
